// extracted by mini-css-extract-plugin
export default {"ConfirmationPop":"MealsPop_ConfirmationPop__Nd2lL","modalBody":"MealsPop_modalBody__gmbcV"};